import type { BroadcastNotificationCategory, BroadcastNotificationsList } from "@/types/notifications"
import { HttpClient, HUB_ROOT } from "@/api/httpClient"

export interface NotificationsListPayload {
	perPage: number
	page: number
	filters?: {
		read?: boolean
		category?: BroadcastNotificationCategory
	}
}

interface NotificationsListParams {
	paginate: true
	per_page: number
	page: number
	read?: 1 | 0
	category?: BroadcastNotificationCategory
}

export default {
	list(payload: NotificationsListPayload) {
		const params: NotificationsListParams = {
			paginate: true,
			per_page: payload.perPage || 50,
			page: payload.page || 1
		}
		if (payload.filters?.read !== undefined) {
			params.read = payload.filters.read ? 1 : 0
		}
		if (payload.filters?.category !== undefined) {
			params.category = payload.filters.category
		}

		return HttpClient.get<BroadcastNotificationsList>(`${HUB_ROOT}/users/notifications`, {
			params
		})
	},
	setOneRead(id: number, type: "read" | "unread") {
		const payload = type === "read" ? { read: JSON.stringify([id]) } : { unread: JSON.stringify([id]) }
		return HttpClient.put(`${HUB_ROOT}/users/notifications`, payload)
	},
	deleteOne(id: number) {
		return HttpClient.delete(`${HUB_ROOT}/users/notifications/${id}`)
	},
	setAllRead() {
		return HttpClient.put(`${HUB_ROOT}/users/notifications/all-read`)
	}
}
